module.exports = __webpack_public_path__ + "img/房屋租赁2.1fed208d.png";